export class ProfessionalSkillItemModel {
  name: string = ''
  description: string = ''
  iconPath: string = ''
  href? = ''
}
